import { createClient } from '@supabase/supabase-js';
import { normaliserVariableEnv, ETAT_VARIABLE } from './services/envConfig';
import { COMPTES_PRODUCTION, adressePourConnexion } from './services/comptesConnexion';

// 2026-08-01 — DETOURAGE OBLIGATOIRE des variables d'environnement.
//
// Incident : la variable VITE_SUPABASE_ANON_KEY de Vercel contenait un
// RETOUR A LA LIGNE final (cle collee avec un \n dans le tableau de bord).
// Vite l'a inline tel quel, et le bundle deploye portait `...J7E\n`.
//
// Consequence, et elle est perverse : les appels REST passaient en 200,
// parce que la cle voyage dans un EN-TETE HTTP, ou l'espace final est tolere.
// Le websocket Realtime, lui, met la cle dans la QUERY STRING : le \n y
// devient `%0A`, la passerelle ne reconnait plus la cle et repond 401
// UNAUTHORIZED_MISSING_API_KEY. D'ou un cockpit qui fonctionne mais dont le
// temps reel est mort, sans aucun message explicite.
//
// Le detourage ici rend l'application immune a cette classe d'erreur, quelle
// que soit la personne qui saisit la variable.
// Regles de normalisation et de refus dans services/envConfig.js, ou elles
// sont testees. Le message nomme la variable, jamais sa valeur.
const lue = (nom, brut) => {
  const r = normaliserVariableEnv(nom, brut);
  if (r.message) {
    // eslint-disable-next-line no-console
    (r.etat === ETAT_VARIABLE.OK ? console.warn : console.error)(`[supabase] ${r.message}`);
  }
  return r.valeur;
};

const supabaseUrl = lue('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL);
const supabaseKey = lue('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY);

export const supabase = (supabaseUrl && supabaseKey)
  ? createClient(supabaseUrl, supabaseKey)
  : null;

export const isCloudEnabled = !!supabase;

// 2026-07-21 — Espace 100 % Anissa (retrait partie Benoit, phase 1).
// Le compte Supabase de Benoit reste techniquement valide (données
// partagées, rollback possible), mais l'UI ne propose plus que Anissa.
export const USERS = ['Anissa'];

export const USER_EMAILS = COMPTES_PRODUCTION;

export async function signIn(username, password) {
  if (!supabase) throw new Error('Cloud non disponible');
  // 2026-08-02 — l'adresse dépend de la BASE qu'on a en face. Sur le staging,
  // `anissa.nutri@gmail.com` n'existe pas : la connexion échouait toujours, et
  // l'écran accusait le mot de passe. Voir services/comptesConnexion.js.
  const email = adressePourConnexion(username, import.meta.env);
  if (!email) throw new Error('Utilisateur inconnu');
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data.user;
}

export async function signOut() {
  if (!supabase) return;
  await supabase.auth.signOut();
}

export async function getCurrentUser() {
  if (!supabase) return null;
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}
